import React from 'react';
import { Row, Col } from "reactstrap";

interface Props {
    icon: any;
    content: any;
}

const PrometInfoIconBox = (props: Props) => {
    return (
        <Row>
            <Col xl={12}>
                <div className='promet-info-icon-box border-bottom border-top py-3 mb-4'>
                    <div className='float-left'>
                        <img className='promet-info-icon-box-icon' src={props.icon} alt="" />
                    </div>
                    <div className='promet-info-icon-box-content float-left'>
                        {props.content}
                    </div>
                    <div className='clearfix'></div>
                </div>
            </Col>
        </Row>
    );
};

export default PrometInfoIconBox;
